import store from 'shared/store'
import floatingLabel from 'views/assets/scripts/floatingLabel'
import formControlValidation from 'views/assets/scripts/formValidation/formControlValidation'
import modal from 'views/assets/scripts/modal'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'

export default async () => {
  const container = document.getElementById('newsletterModalFormContainer')

  const {
    publicConfig: { locale },
    pageProperties: { csrfToken },
  } = store.getPublicRuntimeConfig()
  const catalogs = await loadCatalogs(locale)

  if (!container) return

  const { default: newsletterModalContainer } = await import(
    /* webpackChunkName: "NewsletterModalContainerWithHydration" */
    `./NewsletterModalContainerWithHydration`
  )

  await newsletterModalContainer({
    container,
    locale,
    catalogs,
    csrfToken: csrfToken || '',
  })

  floatingLabel()
  formControlValidation()
  modal()

  if (window?.dataLayer) {
    window.dataLayer.push({ 'event': 'newsletterSubscribe' })
  }
}
